<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :options="users"
      v-model="user_id"
      :reduce="user => user.id"
      :filterBy="filterByForUsers"
      :placeholder="$t('users.selectWorker')"
      label="name"
      @search="debouncedFetchUsers">
      <template slot="no-options">
        <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
        <template v-if="emptyResults">{{ $t('users.noUsersMatchingPhrase') }}&hellip;</template>
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.name }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-user',
  props: [
    'userID'
  ],
  watch: {
    user_id (newValue) {
      this.$bus.$emit('ui-select-user-updated', newValue);
    }
  },
  data () {
    return {
      user_id: null,
      users: [],
      emptyResults: false
    }
  },
  mounted () {
    this.user_id = this.userID;

    if (this.customer_id) {
      this.prefetchCustomer(this.customer_id);
    } else {
      this.customer_id = null;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
        errorKey: 'loadUsersError'
      });
    }

    this.$bus.$on('ui-select-user-reset', this.resetValue);
  },
  methods: {
    filterByForUsers (option, label, search) {
      return (option.name + ' ' + option.email).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchCustomer (userID) {
      if (!userID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/item/' + parseInt(userID, 10),
        outputKey: 'users',
        errorKey: 'loadUsersError',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.user_id = parseInt(userID, 10);
        }
      });
    },
    fetchUsers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/users/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.user_id !== 0 && this.user_id !== null && searchPhrase === '') {
        endpointUrl = '/users/item/' + parseInt(this.user_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'users',
        errorKey: 'loadUsersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchUsers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchUsers(searchPhrase, loadingCallback);
    }, 500),
    resetValue () {
      this.user_id = null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-user-reset', this.resetValue);
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
